import { Stack, styled } from "@mui/material"
import React from "react"

const Dot = styled("span")(({ theme }) => ({
  animationName: "blink",
  animationDuration: "1.4s",
  animationIterationCount: "infinite",
  animationFillMode: "both",
  width: 14,
  height: 14,
  borderRadius: "50%",
  display: "inline-block",
  margin: "0 1px",
  backgroundColor: theme.palette.grey[400],
  '&:nth-of-type(2)': {
    animationDelay: '0.2s'
  },
  '&:nth-of-type(3)': {
    animationDelay: '0.4s'
  },
  "@keyframes blink": {
    "0%": {
      opacity: 0.2
    },
    "20%": {
      opacity: 1
    },
    "100%": {
      opacity: 0.2
    }
  }
}))

const LoadingDots = () => {
  return (
    <Stack direction={'row'}>
      <Dot />
      <Dot />
      <Dot />
    </Stack>
  )
}

export default LoadingDots
